<template>
  <DatePicker v-if="showNewTimeReport" v-model="range" type="daterange" align="right" unlink-panels :clearable="false" :format="format"
    start-placeholder="Start date" end-placeholder="End date" size="small" :picker-options="pickerOptions" class="ReportDateRangeSelector mx-1">
  </DatePicker>
</template>


<script>
import { DatePicker } from 'element-ui';
import DateRangeShortcutMixin from '@/helpers/Mixins/DateRangeShortcutMixin';

export default {
  name: "ReportDateRangeSelector",
  props: ["large", "small", "textbtn"],
  components: { DatePicker },
  mixins: [DateRangeShortcutMixin],

  data() {
    return {
      
    };
  },

  mounted() {
    if (!this.range) {
      this.range = this.defaultRange;
    }
  },

  methods: {},

  computed: {
    showNewTimeReport(){
      return this.$store.state.GlobalSettings.ShowNewTimeReport;
    },

    defaultRange() {
      if (this.$route.name == "TimeReport") {
        return this.lastMonth.range;
      }
      else {
        return this.outputRelativeRange(0, 'isoWeek');
      }
    },

    pickerOptions() {
      return {
        firstDayOfWeek: 1,
        shortcuts: [
          this.thisWeek,
          this.lastWeek,
          this.thisMonth,
          this.lastMonth,
          //this.last90Days,
          this.thisYear,
          this.lastYear,
        ],
      };
    },

    format() {
      return this.$t('servicesystem.formatting.dateformat').replace('YYYY', 'yyyy').replace('DD', 'dd');
    },

    range: {
      get() {
        return this.$store.state.triggerevents.reportDateRange;
      },
      set(update) {
        this.$store.state.triggerevents.reportDateRange = update;
      },
    },
  },

  watch: {},
};
</script>


<style lang="scss">
</style>
